import _ from 'lodash';

import {updateManualCalculateRows} from "../../../actions/sqftManualCalculationFunctions";
import {MANUAL_CALCULATION_ROW_TYPES, SHAPE_PART_ID, SQFT_APPLIANCES} from "../constants";
import store from "../../../store";
import {DEFAULT_MANUAL_CALC_ROW} from "../../../reducers/sqftManualCalculationReducer";
import {getEdgeFeatures} from "./shapeHelper";
import workspace from "../components/canvas/core/workspace";
import sqftShape from "../components/canvas/core/shapes/sqftShape";
import {getCurrentLayout} from "../../appLayout";
import {similarity} from "./dataHelper";
import MovableImage from "../components/canvas/core/shapes/movableImage";
import {containsHEBeforeExtension, findGLBLink, get3dURLsForFeature, splitAndNormalize} from "./sqft3dArHelper";

export const manualCalculateImport = (data) => {
  console.log("import manualcalc data", data);
  let manualCalculationRows = prepareData(data);
  store.dispatch(updateManualCalculateRows(manualCalculationRows));
}

const prepareData = (data) => {
  return {
    [MANUAL_CALCULATION_ROW_TYPES.countertopRows] : prepareCountertopRows(data.countertops),
    [MANUAL_CALCULATION_ROW_TYPES.backsplashRows] : prepareBacksplashRows(data.backsplashes),
    [MANUAL_CALCULATION_ROW_TYPES.edgeRows] : prepareEdgeRows(data.edges),
  }
}

const prepareCountertopRows = (dataCountertops) => {
  let preparedData = [];
  dataCountertops.forEach((dataCountertop, index) => {
    let row = _.clone(DEFAULT_MANUAL_CALC_ROW);
    row.id = dataCountertop.id ? dataCountertop.id : index;
    row.length = dataCountertop.inputLength;
    row.width = dataCountertop.inputWidth;
    preparedData.push(row);
  })

  return preparedData;
}

const prepareBacksplashRows = (dataBacksplashes) => {
  let preparedData = [];
  dataBacksplashes.forEach((dataBacksplash, index) => {
    let row = _.clone(DEFAULT_MANUAL_CALC_ROW);
    row.id = dataBacksplash.id ? dataBacksplash.id : index;
    row.length = dataBacksplash.inputLength;
    row.height = dataBacksplash.inputHeight;
    preparedData.push(row);
  })

  return preparedData;
}

const prepareEdgeRows = (dataEdges) => {
  let preparedData = [];
  dataEdges.forEach((dataEdge, index) => {
    const navItems = getEdgeFeatures();
    const navItem = navItems.find(edge => edge.part.dbFeature.id === dataEdge.featureId);
    let row = _.clone(DEFAULT_MANUAL_CALC_ROW);
    row.id = dataEdge.id ? dataEdge.id : index;
    row.length = dataEdge.inputLength;
    row.height = dataEdge.inputHeight;
    row.selectedFeature = navItem.part;
    preparedData.push(row);
  })

  return preparedData;
}

export const clearManualCalcData = () => {
  for (const manualCalculationRowType in MANUAL_CALCULATION_ROW_TYPES) {
    store.dispatch(updateManualCalculateRows({[manualCalculationRowType]: []}));
  }
}

export const getGroupedShapesByColor = () => {
  const shapes = workspace.getShapes();
  return shapes.flatMap(shp => {
    if (shp.getColorSet) {
      const colorSet = shp.getColorSet();
      return colorSet ? colorSet : [];
    }
    return [];
  })
}

export const getFeatureGlb = (feature) => {
  const threeDSrc = feature.dbFeature.thirdPartyAR3DUrls.map(src => {
    src = src.replace("s3.amazonaws.com/qc-lixil-3dfiles", "dv84u4f1bblk2.cloudfront.net");
    return src
  })
  return threeDSrc.find(url => url.includes(".glb"));
}

export class CabinetsSet {

  static prepareCabinetsSet() {
    const positions = CabinetsSet.prepareCabinetsPositions();
    const cabinetSet = {
      "positions": positions
    }

    // add countertop if bottom_cabinets exist
    if (positions.some(position => position.partId === SHAPE_PART_ID.bottom_cabinet)) {
      let texture = "https://static6.depositphotos.com/1031174/647/i/450/depositphotos_6477080-stock-photo-grungy-background.jpg";
      const state = store.getState();
      if (state.sqftState.selectedCountertop) {
        const layout = getCurrentLayout();
        const countertopFeature = layout.getFeatureById(state.sqftState.selectedCountertop, true);
        if (countertopFeature && countertopFeature.dbFeature.thirdPartyAR3DUrls) {
          const URLByFeatureName = get3dURLsForFeature(countertopFeature);
          texture = URLByFeatureName ? URLByFeatureName : countertopFeature.dbFeature.thirdPartyAR3DUrls[0]
        }
      }

      cabinetSet.countertop = {
        "main": "https://quotecountertops.com/video/sqft/cabinets/Quarter Round_Main Body.glb",
        "edge": "https://quotecountertops.com/video/sqft/cabinets/Quarter Round_Edge.glb",
        "corner": "https://quotecountertops.com/video/sqft/cabinets/Quarter Round_Corner.glb",
        "texture": texture
      }
    }

    return cabinetSet
  }

  static getHighestCabinetValue() {
    const shapes = workspace.getShapes();
    if (shapes.length === 0) {
      return 0;
    }

    return shapes.reduce((acc, current) => {
      let currentShapeHeight = 0;
      if (current instanceof sqftShape && current.partId === SHAPE_PART_ID.top_cabinet) {
        currentShapeHeight = current.shapeCabinet.getShapeHeight();
      } else if (current instanceof MovableImage) {
        currentShapeHeight = current.getThickness();
      }

      if (currentShapeHeight > acc) {
        return currentShapeHeight;
      }

      return acc;
    }, 0);
  }

  static prepareCabinetsPositions() {
    const layout = getCurrentLayout();
    const shapes = workspace.getShapes();

    return shapes.map((shape) => {
      if (shape instanceof sqftShape) {
        let absolutePos = shape.shapeAbsolute.getAbsolutePosition();
        let shapePosition = absolutePos ? absolutePos : shape.getPosition();

        const relatedParentFeature = layout.getFeatureById(shape.relatedParentFeatureId, true);
        if (relatedParentFeature) {
          const shapeFeature = relatedParentFeature.dbFeature.relatedFeatures.find(relatedFeature => relatedFeature.id === shape.featureId);

          return CabinetsSet.prepareRegularCabinetSet(shape, shapePosition, shapeFeature, relatedParentFeature);
        } else {
          console.log("3d model cannot be prepared its parent not found shape.relatedParentFeatureId:", shape.relatedParentFeatureId);
        }
      } if (shape instanceof MovableImage) {
        let absolutePos = shape.shapeAbsolute.getAbsolutePosition();
        const shapePosition = absolutePos ? absolutePos : shape.getPosition();
        const shapeFeature = layout.getFeatureById(shape.featureId);

        if (shapeFeature) {
          return CabinetsSet.prepareImageCabinetSet(shape, shapePosition, shapeFeature);
        }
      }
      return null
    }).filter(cabinetSet => {
      return cabinetSet !== null
    })
  }

  static getShapeCorrectedPos = (rotatedDegrees, position, width, height) => {
    // get radians
    let thetaRad = -(rotatedDegrees * Math.PI / 180);

    // left top corner pos (shape pos)
    let xInit = position.x;
    let yInit = position.y;

    // shape center after rotation
    let xCenterBAfterRotation = xInit + width / 2 * Math.cos(thetaRad) - height / 2 * Math.sin(thetaRad);
    let yCenterBAfterRotation = yInit + width / 2 * Math.sin(thetaRad) + height / 2 * Math.cos(thetaRad);

    // initial shape center
    let xCenterBInitial = xInit + width / 2;
    let yCenterBInitial = yInit + height / 2;

    // shape center - shape center after rotation
    let deltaX = xCenterBInitial - xCenterBAfterRotation;
    let deltaY = yCenterBInitial - yCenterBAfterRotation;

    return {
      x: rotatedDegrees > 0
        ? position.x + deltaX
        : position.x,
      y: rotatedDegrees > 0
        ? position.y + deltaY
        : position.y
    }
  }

  static prepareRegularCabinetSet = (shape, shapePosition, shapeDbFeatureFeature, relatedParentFeature) => {
    if (shapeDbFeatureFeature) {
      console.log("shapeDbFeatureFeature.thirdPartyAR3DUrls", shapeDbFeatureFeature.thirdPartyAR3DUrls);
    }

    if (!shapeDbFeatureFeature || !shapeDbFeatureFeature.thirdPartyAR3DUrls) {
      return null
    }

    function getUrlMatchingByColor() {
      console.log("relatedParentFeature.getFeatureName()", relatedParentFeature.getFeatureName());
      console.log("relatedParentFeature.sharedFeatureName", relatedParentFeature.dbFeature.sharedFeatureName);
      const nameSearch = relatedParentFeature.dbFeature.sharedFeatureName;

      const featureNameParts = splitAndNormalize(nameSearch);

      // 1.urlByFeatureName - Enhanced Matching
      const urlByFeatureName = shapeDbFeatureFeature.thirdPartyAR3DUrls.find(url => {
        const urlParts = splitAndNormalize(url.toLowerCase().split('/').pop().split('.')[0]);
        // Check if all parts of the feature name are present in the URL segment
        return featureNameParts.every(part => urlParts.includes(part));
      });
      console.log("urlByFeatureName", urlByFeatureName);
      if (urlByFeatureName) {
        return urlByFeatureName;
      }

      // 2.urlBySimilarity
      let urlBySimilarity;
      let highestSimilarity = 0.3;
      shapeDbFeatureFeature.thirdPartyAR3DUrls.forEach(url => {
        const name = url.toLowerCase().split('/').pop().split('.')[0];
        const relatedParentFeatureNamePrepared = nameSearch.toLowerCase().split(' ').join('');
        const namePrepared = name.split(' ').join('');
        const similarityScore = similarity(namePrepared, relatedParentFeatureNamePrepared);
        //console.log("name", name);
        //console.log("similarityScore", similarityScore);
        if (similarityScore > highestSimilarity) {
          urlBySimilarity = url;
          highestSimilarity = similarityScore;
        }
      });
      console.log("urlBySimilarity", urlBySimilarity);
      if (urlBySimilarity) {
        return urlBySimilarity
      }

      //3. urlMatchedByColor
      const color = relatedParentFeature.getColorName();
      const urlMatchedByColor = color && color.length > 3
        ? shapeDbFeatureFeature.thirdPartyAR3DUrls.find(thirdPartyAR3DUrls => thirdPartyAR3DUrls.includes(color))
        : null;
      console.log("feature color", color);
      console.log("urlMatchedByColor", urlMatchedByColor);
      if (urlMatchedByColor) {
        return urlMatchedByColor
      }

      //4. urlMatchedByColor
      const urlMatchedByBlackColor = shapeDbFeatureFeature.thirdPartyAR3DUrls.find(thirdPartyAR3DUrls => thirdPartyAR3DUrls.toLowerCase().includes('black'));
      console.log("urlMatchedByBlackColor", urlMatchedByBlackColor);
      if (urlMatchedByBlackColor) {
        return urlMatchedByBlackColor
      }

      //5. urlMatchedByColor
      const firstColorInThirdPartyAR3DUrls = shapeDbFeatureFeature.thirdPartyAR3DUrls[0];
      console.log("firstColorIn ThirdPartyAR3DUrls", firstColorInThirdPartyAR3DUrls);
      return firstColorInThirdPartyAR3DUrls
    }

    const shapeWidth = shape.shapeCabinet.getShapeWidth();
    //if it is cube then we can set target width and resize it
    const targetWidth = shape.getLines().length === 4 ? shape.getSize().width : shapeWidth;
    const shapeHeight = shape.shapeCabinet.getShapeHeight();
    const shapeDepth = shape.shapeCabinet.getShapeDepth();
    const pos = CabinetsSet.getShapeCorrectedPos(shape.rotatedDegrees, shapePosition, shapeWidth, shapeDepth);
    const url = getUrlMatchingByColor().replace(/\s+\.glb$/, '.glb'); //todo remove
    //const url = getUrlMatchingByColor();
    let posY = 0;
    if (shape.partId === SHAPE_PART_ID.top_cabinet) {
      //todo (shape bottom cabinet height + distance between bottom and top cabinets)
      posY = 34 + 18
      if (containsHEBeforeExtension(url)) {
        //upper cabinets was raised in 3d models
        const highestCabinetValue = CabinetsSet.getHighestCabinetValue();
        //console.log("highestCabinetValue", highestCabinetValue);
        posY = 34 + 18 + highestCabinetValue - 36 //shapeHeight (36 that is hardcoded value for all hood cabinets)
      }
    }

    return {
      "partId": shape.partId,
      "x": pos.x,
      "y": posY, // height between floor and roof. 0 is floor
      "z": pos.y,
      "rotation": shape.rotatedDegrees,
      "url": url,
      "target_width": targetWidth,
      "width": shapeWidth,
      "height": shapeHeight, //in sqft wee cabinets from top so we can see this value
      "depth": shapeDepth,
      // "url": shapeDbFeatureFeature && shapeDbFeatureFeature.thirdPartyAR3DUrls
      //   ? shapeDbFeatureFeature.thirdPartyAR3DUrls[0]
      //   : "https://qc-3dfiles.s3.amazonaws.com/ar-composer/W3030.glb" //localGlb
      //: "https://dv84u4f1bblk2.cloudfront.net/6cp14aef9e7rfg6gds5orh1cej7ctlvq.glb"
    }
  }

  static prepareImageCabinetSet = (shape, shapePosition, shapeFeature) => {
    if (!shapeFeature || !shapeFeature.dbFeature || !shapeFeature.dbFeature.thirdPartyAR3DUrls) {
      return null
    }
    //console.log("shapeDbFeatureFeature.thirdPartyAR3DUrls", shapeFeature.dbFeature.thirdPartyAR3DUrls);

    const shapeWidth = +shape.getWidth();
    const shapeHeight = +shape.getThickness();
    const shapeDepth = +shape.getHeight();
    const applianceRotatedDegrees = shape.rotatedDegrees - 90;
    const appliancePosition = {x: shapePosition.x + shapeWidth / 2, y: shapePosition.y}
    const pos = CabinetsSet.getShapeCorrectedPos(applianceRotatedDegrees, appliancePosition, shapeWidth, shapeDepth);
    const url = findGLBLink(shapeFeature.dbFeature.thirdPartyAR3DUrls);
    const yPos = shapeFeature.partId === SQFT_APPLIANCES.hood ? 34 + 18 : 0;
    const partId = shapeFeature.partId === SHAPE_PART_ID.dishwasher ? SHAPE_PART_ID.bottom_cabinet: shapeFeature.partId;

    return {
      "partId": partId,
      "x": pos.x,
      "y": yPos, //todo (shape bottom cabinet height + distance between bottom and top cabinets)
      "z": pos.y,
      "rotation": applianceRotatedDegrees,
      "url": url,
      "width": shapeWidth,
      "height": shapeHeight, //in sqft wee cabinets from top so we can see this value
      "depth": shapeDepth,
    }
  }
}
